import React from 'react'
import { Box, Grid, Typography, Card, CardMedia, Divider } from '@mui/material'
import ServicesHeader from './servicesHeader'
import './services.css'

import turfingExample1 from '../_content/turfing1.webp'
import turfingExample2 from '../_content/after1.webp'
import turfingExample3 from '../_content/turfing2.webp'
import turfingExample4 from '../_content/turfing3.webp'
import turfingExample5 from '../_content/turfing4.webp'
import turfingExample6 from '../_content/turfing5.webp'
import turfingExample7 from '../_content/turfing7.webp'
import turfingExample8 from '../_content/fenceturf.webp'
import turfingExample9 from '../_content/turfing6.webp'

const TurfingServices = () => {
  return (
    <>
      <ServicesHeader background={turfingExample3} text="Turfing & Lawn Care" />

      <Divider orientation='vertical' flexItem sx={{ border: '1px solid white' }} />
      <Box className="top-strip">
        <Typography className="top-strip-text">
          Create and mantain a lush, healthy lawn with our turfing services covering Brentwood and Essex.
        </Typography>
      </Box>
      <Divider orientation='vertical' flexItem sx={{ border: '1px solid white' }} />

      <Box className="section-wrapper">
        <Box className="section-inner">
          <Box className="section-content">

            <Typography className="section-heading" variant="h5">
              Beautiful lawns that last
            </Typography>

            <Typography className="section-subtext">
              From new turf installations to ongoing care, we deliver long-lasting, reliable results.
            </Typography>

            <Box className="section-divider" />

            <Grid container spacing={3} alignItems="stretch">
              {[
                { title: 'Premium Turf', text: 'High-quality turf selected for durability and appearance.' },
                { title: 'Expert Installation', text: 'Proper preparation ensures long-lasting results.' },
                { title: 'Lawn Care', text: 'Maintenance services to keep your lawn in top condition.' },
              ].map((item, i) => (
                <Grid item xs={12} md={4} key={i} sx={{ display: 'flex' }}>
                  <Box className="service-card">
                    <Box>
                      <Typography className="card-title">{item.title}</Typography>
                      <Typography className="card-text">{item.text}</Typography>
                    </Box>
                  </Box>
                </Grid>
              ))}
            </Grid>

          </Box>
        </Box>
      </Box>

      <Box className="image-section">
        <Typography className="image-title" variant="h5">
          Recent Projects
        </Typography>

        <Grid container spacing={3} justifyContent="center">
          {[turfingExample8, turfingExample2, turfingExample9, turfingExample3, turfingExample4, turfingExample7, turfingExample6, turfingExample1, turfingExample5].map((img, i) => (
            <Grid item xs={12} sm={6} md={4} key={i}>
              <Card className="image-card">
                <CardMedia component="img" image={img} className="image-media" />
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    </>
  )
}

export default TurfingServices